// extracted by mini-css-extract-plugin
export default {"button":"Password_button__b2mnC","buttons":"Password_buttons__isJ03"};